var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Formação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.formacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "formacao", $$v);
      },
      expression: "form.filters.formacao"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data de Solicitação",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataSolicitacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataSolicitacao", $$v);
      },
      expression: "form.filters.dataSolicitacao"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data de Realização",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataRealizacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataRealizacao", $$v);
      },
      expression: "form.filters.dataRealizacao"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.form.lists.tiposDeStatus,
      "label": "Status",
      "item-text": "situacao",
      "item-value": "id",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.status,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "status", $$v);
      },
      expression: "form.filters.status"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarFormacao();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Incluir",
      "icon": "mdi-plus",
      "disabled": _vm.isOpeningManterFormacao
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterFormacao();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listFormacoes,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.formacao`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.formacao) + " ")];
      }
    }, {
      key: `item.dataSolicitacao`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarData(item.dataSolicitacao)) + " ")];
      }
    }, {
      key: `item.dataRealizacao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarData(item.dataRealizacao)) + " ")];
      }
    }, {
      key: `item.status`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.status) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar",
            "icon": "mdi-eye-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarFormacao(item);
            }
          }
        }), _vm.podeEditarFormacao(item) && !item.reenviarSolicitacao ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Editar",
            "icon": "mdi-pencil",
            "small": "",
            "disabled": _vm.isOpeningManterFormacao
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterFormacao(item);
            }
          }
        }) : _vm._e(), item.statusId == _vm.statusFormacaoEnum.CONSOLIDADA && item.qtdReagendamento < 3 ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Alterar Data",
            "icon": "mdi-calendar-edit",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogReagendarFormacao(item);
            }
          }
        }) : _vm._e(), item.statusId == _vm.statusFormacaoEnum.REPROVADA_APROVACAO || item.statusId == _vm.statusFormacaoEnum.REPROVADA_CONSOLIDACAO ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Detalhar Reprovação",
            "icon": "mdi-eye-circle-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogJustificativaReprovacao(item, true);
            }
          }
        }) : _vm._e(), !_vm.podeEditarFormacao(item) ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Baixar Solicitação de Formação",
            "icon": "mdi-arrow-down",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.baixarRelatorioPdf(item);
            }
          }
        }) : _vm._e(), item.reenviarSolicitacao ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Reenviar",
            "icon": "mdi-replay",
            "small": "",
            "disabled": _vm.isOpeningManterFormacao
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterFormacao(item);
            }
          }
        }) : _vm._e(), item.status == 'Realizada' && item.passouSeteDias ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Avaliar Formação",
            "icon": "mdi-content-duplicate",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogAvaliacaoFormacao(item);
            }
          }
        }) : _vm._e()];
      }
    }], null, true)
  })], 1), _vm.dialogManterFormacao.visible ? _c('CadastrarFormacaoDialog', {
    attrs: {
      "visible": _vm.dialogManterFormacao.visible,
      "content": _vm.dialogManterFormacao.content,
      "edit": _vm.dialogManterFormacao.edit
    },
    on: {
      "onClose": _vm.fecharDialogManterFormacao,
      "onSave": function ($event) {
        return _vm.buscarFormacao();
      }
    }
  }) : _vm._e(), _vm.dialogReagendarFormacao.visible ? _c('ReagendarFormacaoDialog', {
    attrs: {
      "visible": _vm.dialogReagendarFormacao.visible,
      "content": _vm.dialogReagendarFormacao.content,
      "edit": _vm.dialogReagendarFormacao.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogReagendarFormacao.close();
      },
      "onConfirm": function ($event) {
        return _vm.buscarFormacao();
      }
    }
  }) : _vm._e(), _vm.dialogJustificativaReprovacao.visible ? _c('JustificativaReprovacaoDialog', {
    attrs: {
      "visible": _vm.dialogJustificativaReprovacao.visible,
      "content": _vm.dialogJustificativaReprovacao.content,
      "edit": _vm.dialogJustificativaReprovacao.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogJustificativaReprovacao.close();
      }
    }
  }) : _vm._e(), _vm.dialogAvaliarFormacao.visible ? _c('AvaliacaoFormacaoDialog', {
    attrs: {
      "visible": _vm.dialogAvaliarFormacao.visible,
      "content": _vm.dialogAvaliarFormacao.content,
      "edit": _vm.dialogAvaliarFormacao.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogAvaliarFormacao.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }